import axios from "axios";
import { authHeader } from "./utils";
import {
  GET_COMMUNICATOR,
  LIST_COMMUNICATOR,
  // LIST_AVAILABLE_COMMUNICATOR,
} from "./types";

export const getCommunicator = (id) => async (dispatch) => {
  const res = await axios.get(`/api/communicators/${id}`, {
    headers: authHeader(),
  });
  console.log("res", res.data);
  dispatch({ type: GET_COMMUNICATOR, payload: res.data });
};

export const fetchCommunicators =
  ({ page, limit, all }) =>
  async (dispatch) => {
    const res = await axios.get("/api/communicators", {
      headers: authHeader(),
      params: { page, limit, all },
    });
    console.log("res", res.data);
    dispatch({ type: LIST_COMMUNICATOR, payload: res.data });
  };

export const submitCommunicator =
  ({ communicator }) =>
  () =>
    new Promise(async (resolve, reject) => {
      try {
        const res = await axios.post("/api/communicators", communicator, {
          headers: authHeader(),
        });
        resolve(res.data);
      } catch (error) {
        reject(error);
      }
    });

export const updateCommunicator =
  ({ communicator, id }) =>
  () =>
    new Promise(async (resolve, reject) => {
      try {
        const res = await axios.put(`/api/communicators/${id}`, communicator, {
          headers: authHeader(),
        });
        resolve(res.data);
      } catch (error) {
        reject(error);
      }
    });

export const deleteCommunicator =
  ({ id }) =>
  () =>
    new Promise(async (resolve, reject) => {
      try {
        await axios.delete(`/api/communicators/${id}`, {
          headers: authHeader(),
        });
        resolve();
      } catch (error) {
        reject(error);
      }
    });

export const fetchAvailableCommunicators = () => async (dispatch) => {
  const res = await axios.get("/api/communicators/available", {
    headers: authHeader(),
  });
  console.log("res", res.data);
  dispatch({ type: LIST_COMMUNICATOR, payload: res.data });
  // dispatch({ type: LIST_AVAILABLE_COMMUNICATOR, payload: res.data });
};
